import { render, staticRenderFns } from "./header-layout.vue?vue&type=template&id=3d746b4d"
import script from "./header-layout.vue?vue&type=script&lang=js"
export * from "./header-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports